import { vnTemplate } from '../../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import { filterDate_template } from '~/components/templates/filterDate_template';
import { filterSimple_template } from '../../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template';
import { multipleSelector_template } from '../../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template';
import { listPagePagination_template as pagination_template } from '~/components/templates/listPagePagination_template';
import { resultsInfo_template } from '../../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template';
import { listPageSelect_template } from '~/components/templates/listPageSelect_template';
import { renderAdminLeadPartnersTable, renderAdminLeadsTable } from '../../recruiting/admin-leads-table';
import { html, LpButton, LpFilterBar, LpIcon, LpLoadingOverlay, LpPageHeader, raw } from '~/design-system';
import { getAdminLeadStatusOption } from '~/utils/adminLeadStatus';
import { legacyIconNameToPhosphorIconName, setOptionalIconName } from '~/utils/iconName';
export class adminLeads_template extends vnTemplate {
    /**
     * Return the template key used by the Valnet template framework.
     *
     * @return string
     */
    getTemplateName() {
        return 'adminLeads-template';
    }
    /**
     * Return the CSS classes applied to the template root element.
     *
     * @return Array<string>
     */
    getMainElementClasses() {
        return ['w-content'];
    }
    /**
     * Initialize nested template partials used by this template.
     *
     * @return void
     */
    initPartial() {
        const vm = this.getTemplateViewModel();
        this.dateFilter = new filterDate_template('adminLeadsDateFilter', vm, this.caller);
        this.dateFilter.setLabel('');
        this.dateFilter.setStartPickerId('admin-leads-start-date-picker');
        this.dateFilter.setEndPickerId('admin-leads-end-date-picker');
        const date = new Date();
        date.setHours(0, 0, 0, 0);
        let firstOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
        if (date.getTime() === firstOfMonth.getTime()) {
            firstOfMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
            date.setDate(date.getDate() - 1);
        }
        else {
            date.setDate(date.getDate() - 1);
        }
        this.dateFilter.setDateRange(firstOfMonth, date);
        this.resultInfos = new resultsInfo_template('adminLeadsResultInfo', vm, this.caller);
        this.pagination = new pagination_template('adminLeadsPagination', vm, this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 50;
        this.filterSimple = new filterSimple_template('adminLeadsKeywordSearch', vm, this.caller);
        this.filterSimple.setPlaceholder('Search leads');
        this.channelFilter = new listPageSelect_template('adminLeadsChannelFilter', vm, this.caller);
        this.channelFilter.setLabel('Channel');
        this.channelFilter.setShowLabelPrefix(true);
        this.channelFilter.setIcon('grid');
        this.channelFilter.bindValue(vm.channelId);
        this.statusFilter = new listPageSelect_template('adminLeadsStatusFilter', vm, this.caller);
        this.statusFilter.setLabel('Status');
        this.statusFilter.setShowLabelPrefix(true);
        this.statusFilter.setIcon('info');
        this.statusFilter.bindValue(vm.sendFlag);
        this.updateSendFlagSelect = new listPageSelect_template('adminLeadsUpdateSendFlagSelect', vm, this.caller);
        this.updateSendFlagSelect.setLabel('Status');
        this.updateSendFlagSelect.setFormField(true);
        this.updateSendFlagSelect.setOptions([{ id: '', name: 'No status change' }]);
        this.updateSendFlagSelect.bindValue(vm.updateSendFlag);
        this.partnersFilter = new multipleSelector_template('adminLeadsPartnersFilter', vm, this.caller);
        this.partnersFilter.setLabel('Partners');
        setOptionalIconName(this.partnersFilter, legacyIconNameToPhosphorIconName('users'));
        this.partnersFilter.setFilterContainerClass('lib-dropdown');
        this.partnersFilter.setTagContainerId('admin-leads-selected-partners');
        this.partnersFilter.setTagContainerCaption('Selected partners:');
        this.subunitsFilter = new multipleSelector_template('adminLeadsSubunitsFilter', vm, this.caller);
        this.subunitsFilter.setLabel('Subunits');
        setOptionalIconName(this.subunitsFilter, 'house');
        this.subunitsFilter.setFilterContainerClass('lib-dropdown');
        this.subunitsFilter.setTagContainerId('admin-leads-selected-subunits');
        this.subunitsFilter.setTagContainerCaption('Selected subunits:');
    }
    /**
     * Build the Knockout view model used by this template.
     *
     * @return any
     */
    buildViewModel() {
        const self = this;
        return {
            rows: ko.observableArray([]),
            sendFlags: ko.observableArray([]),
            orderBy: ko.observable('createdDate'),
            orderByDirection: ko.observable('DESC'),
            orderByAndDirection: ko.observable('createdDate_DESC'),
            channelId: ko.observable(''),
            sendFlag: ko.observable(''),
            updateSendFlag: ko.observable(''),
            clearTransmissionFields: ko.observable(false),
            leadDrawer: ko.observable(null),
            selectedCount: ko.pureComputed(function () {
                const rows = self.getTemplateViewModel().rows() || [];
                let count = 0;
                for (let row of rows) {
                    if (row.selected) {
                        count++;
                    }
                }
                return count;
            }),
            onClickReorder: function (value, data, event) { self.onClickReorder(value, data, event); },
            onClickDownload: function () { self.caller.downloadCsv(); },
            onClickViewLead: function (row) { self.caller.viewLead(row.id); },
            onClickUpdate: function () { self.caller.updateSelectedLeads(); },
            onClickToggleRow: function (row) { self.caller.toggleRow(row.id); },
            onClickToggleAll: function () { self.caller.toggleAllRows(); },
            onClickCloseLeadDrawer: function () { self.caller.closeLeadDrawer(); },
        };
    }
    /**
     * Return the HTML markup for this template.
     *
     * @return string
     */
    getTemplateHtml() {
        return `
            ${LpPageHeader({
            title: 'Admin Leads',
            description: 'Review submitted leads, partner selections, and transmission status.',
            icon: 'users',
            controls: LpFilterBar({
                className: 'admin-leads-control-bar',
                controls: html `
                        <div class="list-page-filter-cell">
                            <div class="lib-date-picker">
                                ${raw(this.dateFilter.getHtmlBuild())}
                            </div>
                        </div>

                        <div class="list-page-filter-cell">
                            ${raw(this.channelFilter.getHtmlBuild())}
                        </div>

                        <div class="list-page-filter-cell">
                            ${raw(this.statusFilter.getHtmlBuild())}
                        </div>

                        <div class="list-page-filter-cell admin-leads-multi-filter-cell">
                            ${raw(this.partnersFilter.getHtmlBuild())}
                        </div>

                        <div class="list-page-filter-cell admin-leads-multi-filter-cell">
                            ${raw(this.subunitsFilter.getHtmlBuild())}
                        </div>
                    `,
                actions: LpButton({
                    label: 'Export',
                    prefixIcon: 'export',
                    size: 'base',
                    variant: 'primary',
                    attributes: {
                        'data-bind': 'click: onClickDownload',
                    },
                }),
            }),
        })}


            <div class="w-filters-selected admin-leads-selected-filters">
                <div id="filters-selected" class="filters-selected">
                    <div id="admin-leads-selected-partners"></div>
                    <div id="admin-leads-selected-subunits"></div>
                </div>
            </div>

            <div class="list-page-module admin-leads-module">
                <div class="data-module__body list-page-module__body" id="list-results">
                    ${renderAdminLeadsTable({
            getSortAttributes: (column) => this.getSortAttributes(column),
            searchHtml: raw(this.filterSimple.getHtmlBuild()),
        })}
                </div>
                <div class="data-module__footer list-page-module__footer">
                    <div class="list-page-module__toolbar">
                        <div class="list-page-module__meta">
                            ${this.resultInfos.getHtmlBuild()}
                        </div>
                        <div class="list-page-module__pagination">
                            ${this.pagination.getHtmlBuild()}
                        </div>
                    </div>
                </div>
            </div>

            <section class="admin-leads-panel admin-leads-bulk-actions" data-bind="visible: selectedCount() > 0">
                <div class="admin-leads-panel__header">
                    <h2>Bulk Actions</h2>
                    <span data-bind="text: selectedCount() + ' selected'"></span>
                </div>
                <div class="admin-leads-bulk-row">
                    <label class="admin-leads-bulk-field">
                        <span class="admin-leads-filter-label">Update Lead Status To</span>
                        ${this.updateSendFlagSelect.getHtmlBuild()}
                    </label>
                    <label class="admin-leads-bulk-check" for="admin-leads-clear-transmission">
                        <input type="checkbox" id="admin-leads-clear-transmission" data-bind="checked: clearTransmissionFields">
                        <span>Clear transmission fields</span>
                    </label>
                    ${LpButton({
            label: 'Update Selected Leads',
            variant: 'primary',
            attributes: {
                'data-bind': 'event: { click: onClickUpdate }',
            },
        })}
                </div>
            </section>

            <div class="admin-leads-drawer-backdrop" data-bind="visible: leadDrawer, click: onClickCloseLeadDrawer">
                <aside class="admin-leads-drawer" role="dialog" aria-modal="true" aria-labelledby="admin-leads-drawer-title" data-bind="with: leadDrawer, click: function () { return true; }, clickBubble: false">
                    <header class="admin-leads-drawer__header">
                        <div class="admin-leads-drawer__title-group">
                            <span class="admin-leads-drawer__eyebrow">
                                ${LpIcon({ name: 'user-circle', size: 16, className: 'admin-leads-drawer__title-icon' })}
                                <span>Lead details</span>
                            </span>
                            <h2 id="admin-leads-drawer-title" data-bind="text: title"></h2>
                        </div>
                        ${LpButton({
            ariaLabel: 'Close',
            prefixIcon: 'x',
            size: 'sm',
            shape: 'square',
            variant: 'ghost',
            attributes: {
                'data-bind': 'click: $parent.onClickCloseLeadDrawer',
            },
        })}
                    </header>
                    <div class="admin-leads-drawer__body lp-loading-overlay-host">
                        ${LpLoadingOverlay({
            label: 'Loading lead details...',
            loaderLabel: 'Loading lead details',
            className: 'admin-leads-drawer__loading',
            attributes: {
                'data-bind': 'visible: isLoading',
            },
        })}

                        <div data-bind="visible: !isLoading">
                            <section class="admin-leads-drawer__section" data-bind="visible: identityFields.length > 0">
                                <div class="admin-leads-drawer__section-header">
                                    <h3>
                                        ${LpIcon({ name: 'identification-card', size: 16, className: 'admin-leads-drawer__section-icon' })}
                                        <span>Identity details</span>
                                    </h3>
                                    <p>Core contact information used to identify this lead.</p>
                                </div>
                                <dl class="admin-leads-description-list" data-bind="foreach: identityFields">
                                    <div class="admin-leads-description-row">
                                        <dt data-bind="text: label"></dt>
                                        <dd data-bind="text: value"></dd>
                                    </div>
                                </dl>
                            </section>

                            <section class="admin-leads-drawer__section">
                                <div class="admin-leads-drawer__section-header">
                                    <h3>
                                        ${LpIcon({ name: 'paper-plane-tilt', size: 16, className: 'admin-leads-drawer__section-icon' })}
                                        <span>Submissions</span>
                                    </h3>
                                    <p>Submission timing, current status, and partner delivery details.</p>
                                </div>
                                <dl class="admin-leads-description-list" data-bind="visible: submissionFields.length > 0, foreach: submissionFields">
                                    <div class="admin-leads-description-row">
                                        <dt data-bind="text: label"></dt>
                                        <dd data-bind="text: value"></dd>
                                    </div>
                                </dl>
                                <div class="admin-leads-partners-table" data-bind="visible: !isLoading && partners.length > 0">
                                    ${renderAdminLeadPartnersTable()}
                                </div>
                                <p class="admin-leads-drawer__empty" data-bind="visible: !isLoading && partners.length === 0">No partners attached to this lead.</p>
                            </section>

                            <section class="admin-leads-drawer__section" data-bind="visible: sourceFields.length > 0">
                                <div class="admin-leads-drawer__section-header">
                                    <h3>
                                        ${LpIcon({ name: 'target', size: 16, className: 'admin-leads-drawer__section-icon' })}
                                        <span>Source</span>
                                    </h3>
                                    <p>Campaign, channel, and attribution context for this lead.</p>
                                </div>
                                <dl class="admin-leads-description-list" data-bind="foreach: sourceFields">
                                    <div class="admin-leads-description-row">
                                        <dt data-bind="text: label"></dt>
                                        <dd data-bind="text: value"></dd>
                                    </div>
                                </dl>
                            </section>

                            <details class="admin-leads-raw-json" open data-bind="visible: rawJson !== ''">
                                <summary>
                                    <span>Raw Payload</span>
                                    ${LpIcon({ name: 'caret-down', size: 16, className: 'admin-leads-raw-json__chevron' })}
                                </summary>
                                <pre class="admin-leads-json-content" data-bind="text: rawJson"></pre>
                            </details>
                        </div>
                    </div>
                </aside>
            </div>
        `;
    }
    getSortAttributes(column) {
        return {
            'data-bind': `click: onClickReorder.bind($data, '${column}'), css: { 'is-desc': orderByAndDirection()=='${column}_DESC', 'is-asc': orderByAndDirection()=='${column}_ASC' }`,
        };
    }
    /**
     * Build the request payload from the current view model state.
     *
     * @return object
     */
    getViewModelForRequest() {
        const vm = this.getTemplateViewModel();
        const paginationVm = this.getPaginationViewModel();
        return {
            sortBy: vm.orderBy(),
            sortDirection: vm.orderByDirection(),
            dateFrom: this.dateFilter.getTemplateViewModel().startDate(),
            dateTo: this.dateFilter.getTemplateViewModel().endDate(),
            channelId: vm.channelId(),
            sendFlag: vm.sendFlag(),
            partnerIds: this.partnersFilter.getSelectedItems(),
            subunitIds: this.subunitsFilter.getSelectedItems(),
            keyword: this.filterSimple.getTemplateViewModel().filterKeyword(),
            pagination: paginationVm,
        };
    }
    /**
     * Return the pagination partial view model.
     *
     * @return any
     */
    getPaginationViewModel() {
        return this.pagination ? this.pagination.getTemplateViewModel() : null;
    }
    /**
     * Handle build date picker calendar.
     *
     * @return void
     */
    buildDatePickerCalendar() {
        this.dateFilter.buildCalendarWhenReady();
    }
    /**
     * Set view model from request on the view model.
     *
     * @param params Array<any>
     * @return void
     */
    setViewModelFromRequest(params) {
        const vm = this.getTemplateViewModel();
        if (typeof params['pagination'] !== 'undefined' && params['pagination'] && vm.pagination && typeof vm.pagination.pageNumber === 'function') {
            vm.pagination.pageNumber(Math.max(1, Number(params['pagination'].pageNumber || 1)));
        }
        else if (typeof params['pageNumber'] !== 'undefined' && vm.pagination && typeof vm.pagination.pageNumber === 'function') {
            vm.pagination.pageNumber(Math.max(1, Number(params['pageNumber'])));
        }
        if (typeof params['sortBy'] !== 'undefined') {
            vm.orderBy(params['sortBy']);
        }
        if (typeof params['sortDirection'] !== 'undefined') {
            const direction = String(params['sortDirection']).toUpperCase() === 'ASC' ? 'ASC' : 'DESC';
            vm.orderByDirection(direction);
            vm.orderByAndDirection(vm.orderBy() + '_' + direction);
        }
        if (typeof params['dateFrom'] !== 'undefined' || typeof params['dateTo'] !== 'undefined') {
            this.dateFilter.getTemplateViewModel().startDate(params['dateFrom'] || null);
            this.dateFilter.getTemplateViewModel().endDate(params['dateTo'] || null);
            this.dateFilter.getTemplateViewModel().isActive(false);
        }
        if (typeof params['channelId'] !== 'undefined') {
            vm.channelId(params['channelId']);
        }
        if (typeof params['sendFlag'] !== 'undefined') {
            vm.sendFlag(params['sendFlag']);
        }
        if (typeof params['keyword'] !== 'undefined') {
            this.filterSimple.getTemplateViewModel().filterKeyword(params['keyword']);
            this.filterSimple.getTemplateViewModel().filterInputClearButton(params['keyword'] ? 1 : 0);
        }
        this.setMultiSelectFromUrl(this.partnersFilter, params['partnerIds']);
        this.setMultiSelectFromUrl(this.subunitsFilter, params['subunitIds']);
    }
    /**
     * Set multi select from url on the view model.
     *
     * @param filter multipleSelector_template
     * @param value any
     * @return void
     */
    setMultiSelectFromUrl(filter, value) {
        if (typeof value === 'undefined' || value === null || value === '') {
            return;
        }
        const ids = Array.isArray(value) ? value : String(value).split(',');
        filter.setSeletedItemIds(ids.map((id) => String(id)), true);
    }
    /**
     * Set rows on the view model.
     *
     * @param rows Array<any>
     * @return void
     */
    setRows(rows) {
        this.getTemplateViewModel().rows(rows);
    }
    /**
     * Apply channel references to the view model.
     *
     * @param channels Array<{ id: number; name: string }>
     * @return void
     */
    setChannels(channels) {
        this.channelFilter.setOptions([
            { id: '', name: 'Channel' },
            ...(channels || []).map((channel) => ({
                id: String(channel.id),
                name: channel.name,
            })),
        ]);
    }
    /**
     * Set send flags on the view model.
     *
     * @param flags Array<{ id: number; name: string }>
     * @return void
     */
    setSendFlags(flags) {
        const options = (flags || []).map((flag) => getAdminLeadStatusOption(flag));
        this.statusFilter.setOptions([
            { id: '', name: 'Status' },
            ...options,
        ]);
        this.updateSendFlagSelect.setOptions([
            { id: '', name: 'No status change' },
            ...options,
        ]);
        this.getTemplateViewModel().sendFlags(flags || []);
    }
    /**
     * Apply partner references to the view model.
     *
     * @param partners Array<{ id: number; name: string }>
     * @return void
     */
    setPartners(partners) {
        this.partnersFilter.setItems(partners || []);
    }
    /**
     * Set subunits on the view model.
     *
     * @param subunits Array<{ id: number; name: string }>
     * @return void
     */
    setSubunits(subunits) {
        this.subunitsFilter.setItems(subunits || []);
    }
    /**
     * Update the result-info partial with list metadata.
     *
     * @param totalResults number
     * @param totalPages number
     * @param execTime number
     * @return void
     */
    setResultInfo(totalResults, totalPages, execTime) {
        this.resultInfos.setNbResults(totalResults);
        this.resultInfos.setNbPages(totalPages);
        this.resultInfos.setExecutionTime(execTime);
    }
    /**
     * Update the pagination partial with the result count.
     *
     * @param totalCount any
     * @return void
     */
    updatePagination(totalCount) {
        if (this.pagination) {
            this.pagination.setNumberItemToPaginate(totalCount);
        }
    }
    /**
     * Reset the list pagination to the first page.
     *
     * @return void
     */
    resetPageNumber() {
        const paginationVm = this.getPaginationViewModel();
        if (paginationVm && typeof paginationVm.pageNumber === 'function') {
            paginationVm.pageNumber(1);
        }
    }
    /**
     * Set lead drawer data on the view model.
     *
     * @param drawer any
     * @return void
     */
    setLeadDrawer(drawer) {
        this.getTemplateViewModel().leadDrawer(drawer);
    }
    /**
     * Close the lead details drawer.
     *
     * @return void
     */
    closeLeadDrawer() {
        this.getTemplateViewModel().leadDrawer(null);
    }
    /**
     * Handle on click reorder.
     *
     * @param value any
     * @param data any
     * @param event any
     * @return void
     */
    onClickReorder(value, data, event) {
        if (typeof data.orderBy === 'undefined') {
            data = this.getTemplateViewModel();
        }
        data.orderBy(value);
        if (data.orderByAndDirection() && data.orderByAndDirection().includes(value)) {
            data.orderByDirection(data.orderByDirection() === 'DESC' ? 'ASC' : 'DESC');
        }
        else {
            data.orderByDirection('DESC');
        }
        data.orderByAndDirection(value + '_' + data.orderByDirection());
        this.caller.listReorder();
    }
}
